import {Box, Row} from 'components/Grid';
import {IProductShort} from 'modules/products/types';
import style from './style.module.scss';
import {Modal} from 'modules/modals/components/Modal';
import {MODALS} from 'modules/modals/constants';
import React, {useCallback} from 'react';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {showModal} from 'modules/modals/thunks';
import dynamic from 'next/dynamic';
import {ModalLazyLoader} from 'components/ModalLazyLoader';
import {BrandXAbout} from 'modules/brands/components/About';
import {BrandXBanner} from 'modules/brands/components/Banner';
import {BrandXListing} from 'modules/brands/components/Listing';
import {IBrand} from 'modules/brands/models';
import {Breadcrumbs} from 'modules/breadcrumbs/components/Breadcrumbs';
import {usePageViewGtag} from 'hooks/analytics/gtag/usePageViewGtag';
import {useProductsViewGtag} from 'hooks/analytics/gtag/useProductsViewGtag';
import {IBreadcrumb} from 'modules/seo/types';
import {EventPortalName} from 'modules/google-analytics/constants';

const BrandXModal = dynamic(() => import('modules/brands/components/BrandXModal'), {
    loading: () => <ModalLazyLoader />,
});

interface IProps {
    brandX: IBrand;
    products?: IProductShort[];
    breadcrumbs?: IBreadcrumb[];
}

export function BrandXPage({brandX, products, breadcrumbs = []}: IProps) {
    usePageViewGtag('BRAND_PAGE', EventPortalName.Brand, 'Brand', brandX?.title);
    useProductsViewGtag(products, brandX?.title, 'BRAND_PAGE', 'Товары бренда');

    const dispatch = useAppDispatch();

    const {logo, description, title, presentation, mainPhoto} = brandX;

    const handleClick = useCallback(() => {
        dispatch(showModal(MODALS.BRAND_X_MODAL.name));
    }, [dispatch]);

    return (
        <>
            <Box>
                <Breadcrumbs breadcrumbs={breadcrumbs} />
            </Box>
            <Box className={style.brandsXPage}>
                <BrandXAbout description={description} logo={logo} title={title} />
                {Boolean(presentation?.url || mainPhoto?.url) && (
                    <BrandXBanner
                        className={style.banner}
                        mainPhoto={mainPhoto}
                        onClick={handleClick}
                        presentation={presentation}
                    />
                )}
                {products && 0 < products.length && (
                    <Row>
                        <BrandXListing products={products} />
                    </Row>
                )}
            </Box>
            <Modal name={MODALS.BRAND_X_MODAL.name} willMount={true}>
                <BrandXModal title={title} videoLink={presentation?.url} />
            </Modal>
        </>
    );
}
